<template>
  <v-card elevation="3" outlined class="mb-4">
    <v-card-title class="mycard-title-1 fsize-4 fcolor-1 bg-color-1">
      <v-icon class="mr-2" color="white">mdi-account</v-icon>
      Member Details
    </v-card-title>
    <v-card-text>
      <v-container>
        <!-- Member Photo and Basic Info Row -->
        <v-row class="mb-4">
          <v-col cols="12" md="3" class="text-center">
            <v-avatar size="150" class="mb-3">
              <v-img
                :src="memberInfo.MemberImagePath"
                :alt="memberInfo.MemberName"
                @error="onImageError"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-icon size="60" color="grey lighten-5"
                      >mdi-account</v-icon
                    >
                  </v-row>
                </template>
              </v-img>
            </v-avatar>
            <div class="text-h6 font-weight-bold">
              {{ memberInfo.MemberName }}
            </div>
            <div class="text-subtitle-2 text--secondary">
              {{ memberInfo.Profession }}
            </div>
          </v-col>
          <v-col cols="12" md="9">
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <div class="info-item">
                  <div class="info-label">
                    <v-icon small class="mr-1">mdi-card-account-details</v-icon>
                    Membership ID
                  </div>
                  <div class="info-value">{{ memberInfo.MembershipId }}</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="info-item">
                  <div class="info-label">
                    <v-icon small class="mr-1">mdi-calendar</v-icon>
                    Date of Birth
                  </div>
                  <div class="info-value">{{ memberInfo.DateOfBirth }}</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="info-item">
                  <div class="info-label">
                    <v-icon small class="mr-1">mdi-calendar-check</v-icon>
                    Date of Joining
                  </div>
                  <div class="info-value">{{ memberInfo.DateOfJoining }}</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="info-item">
                  <div class="info-label">
                    <v-icon small class="mr-1">mdi-school</v-icon>
                    Education
                  </div>
                  <div class="info-value">
                    {{ memberInfo.EducationalQualification }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="info-item">
                  <div class="info-label">
                    <v-icon small class="mr-1">mdi-phone</v-icon>
                    Mobile Number
                  </div>
                  <div class="info-value">{{ memberInfo.MobileNumber }}</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="info-item">
                  <div class="info-label">
                    <v-icon small class="mr-1">mdi-email</v-icon>
                    Email ID
                  </div>
                  <div class="info-value">{{ memberInfo.EmailId }}</div>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="info-item">
                  <div class="info-label">
                    <v-icon small class="mr-1">mdi-map-marker</v-icon>
                    Address
                  </div>
                  <div class="info-value">{{ memberInfo.AddressTxt }}</div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Offices Held -->
        <v-row
          v-if="officesHeldData && officesHeldData.length > 0"
          class="mt-4"
        >
          <v-col cols="12">
            <div class="subsection-title">
              <v-icon small class="mr-1">mdi-briefcase</v-icon>
              Offices Held
            </div>
            <v-data-table
              :headers="officesHeldHeader"
              :items="officesHeldData"
              hide-default-footer
              disable-sort
              class="elevation-1 mt-2"
              :items-per-page="-1"
            >
              <template v-slot:[`item.YearName`]="{ item }">
                <v-chip small color="primary" dark>{{ item.YearName }}</v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "MemberDetailsCard",
  props: {
    memberInfo: {
      type: Object,
    },
    officesHeldHeader: {
      type: Array,
    },
    officesHeldData: {
      type: Array,
    },
  },
  methods: {
    onImageError() {
      // Handle image load error by setting a default placeholder
      console.log("Failed to load member photo");
    },
  },
};
</script>

<style lang="scss" scoped>
.info-item {
  margin-bottom: 16px;

  .info-label {
    font-size: 12px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
  }

  .info-value {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
    word-break: break-word;
  }
}

.subsection-title {
  font-size: 16px;
  font-weight: 600;
  color: #1976d2;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.mycard-title-1 {
  font-family: sans-serif;
  padding: 16px;
  text-align: left;
  word-break: break-word;
  line-height: normal;
}

.fsize-4 {
  font-size: 18px !important;
}

.fcolor-1 {
  color: #fff !important;
}

.bg-color-1 {
  background-color: #3a67b1;
}
</style>
